<template>
  <div class="tab">
    <draggable
      class="fields"
      :group="`profile-tab-${_uid}`"
      :list="fields"
      :force-fallback="true"
      ghost-class="field-ghost"
      @change="resortFields"
    >
      <div
        v-for="field in fields"
        :key="field.id"
        class="field"
        :data-size="getFieldSize(field)"
        :data-type="getFieldType(field)"
        :data-system="field.isSystem"
        :class="{
          'field--new-line': field.newLine,
        }"
      >
        <div class="field__controls">
          <div class="field__format"></div>
          <div class="field__actions">
            <c-button
              :id="`field-actions-${field.id}`"
              v-b-popover.html="{
                container: '#app',
                trigger: 'hover blur',
                boundary: 'window',
                content: 'Действия',
                placement: 'top',
              }"
              class="field__menu"
              tabindex="-1"
              size="iconic"
              icon="menu"
            />

            <c-button
              v-b-popover.html="{
                container: '#app',
                trigger: 'hover blur',
                boundary: 'window',
                content: 'Отображать параметр с новой строки',
                placement: 'top',
              }"
              class="field__new-line"
              tabindex="-1"
              size="iconic"
              icon="new-line"
              @click="setNewLine(field)"
            />

            <c-button
              v-b-popover.html="{
                container: '#app',
                trigger: 'hover blur',
                boundary: 'window',
                content: 'Переместить',
                placement: 'top',
              }"
              class="field__move"
              size="iconic"
              icon="arrows-constructor"
            />

            <dropdown-menu
              :target="`field-actions-${field.id}`"
              :list="fieldActions"
              custom-class="field-menu"
              @click="onAction($event, field)"
            />
          </div>
        </div>

        <profile-field class="field__preview" :field="field" :preview="true" />
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import CButton from "@/components/controls2/Button";

import DropdownMenu from "@/components/dropdown-menu";
import ProfileField from "@/domains/profile/components/ProfileField";
import { getFieldSize } from "@/domains/profile/utils/get-field-size";
import { getFieldTypeConfig } from "@/domains/profile/constants/field-types";

export default {
  components: { draggable, CButton, DropdownMenu, ProfileField },
  props: ["fields"],

  data() {
    return {
      fieldActions: [
        {
          id: "editField",
          text: "Редактировать",
          icon: "pencil",
        },
        {
          id: "moveField",
          text: "Перенести во вкладку",
          icon: "change-tab",
        },
        {
          id: "removeField",
          text: "Удалить",
          icon: "bin",
          iconColor: "secondary",
        },
      ],
    };
  },

  methods: {
    getFieldType(field) {
      const fieldConfig = getFieldTypeConfig(field);
      return fieldConfig.id;
    },
    getFieldSize(field) {
      return getFieldSize(field);
    },

    onAction(action, field) {
      const { id } = action;
      this.$emit(id, field);
    },

    resortFields() {
      window.dispatchEvent(new Event("resize"));
      const order = this.fields.map((field, i) => {
        const params = {
          id: field.id,
          sort: i + 1,
          new_line: field.newLine ? 1 : 0,
        };

        return params;
      });
      this.$store.dispatch("profile/sortFields", order);
    },

    setNewLine(field) {
      this.$set(field, "newLine", !field.newLine);
      this.resortFields();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
@import "~@/assets/styles/decoration";
@import "~@/assets/styles/grid";
// .tab {
//   --profile-columns-count: 12;
//   --profile-column-width: calc(100% / var(--profile-columns-count));
//   --profile-xs-field: 6;
//   --profile-sm-field: 6;
//   --profile-md-field: 12;
//   --profile-lg-field: 12;
//   --profile-xl-field: 12;
//   --profile-xxl-field: 12;

//   @include bootstrapMd {
//     --profile-columns-count: 10;
//     --profile-xs-field: 1;
//     --profile-sm-field: 2;
//     --profile-md-field: 3;
//     --profile-lg-field: 4;
//     --profile-xl-field: 6;
//     --profile-xxl-field: 10;
//   }

//   @include bootstrapXl {
//     --profile-columns-count: 12;
//     --profile-xxl-field: 9;
//   }
// }

.fields {
  &:after {
    content: "";
    display: block;
    clear: both;
  }
  margin-top: -1px;
  padding-right: 1px;
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.field {
  padding: 10px 15px 15px;
  min-height: 100px;
  grid-column: span 12;
  position: relative;
  background: white;
  display: flex;
  flex-direction: column;
  cursor: move;

  &[data-type="photo"] {
    min-height: 200px;
    grid-row: span 2;
  }

  &[data-type="socials"] {
    min-width: 430px;
  }

  &[data-type="boolean"],
  &[data-type="covid"],
  &[data-type="travelling-work"],
  &[data-type="friends-in-company"] {
    min-height: 76px;
  }

  &:before {
    content: "";
    pointer-events: none;
    position: absolute;
    left: 0;
    right: -1px;
    top: 0;
    bottom: -1px;
    border: 1px solid #dfe4ef;
  }

  &--new-line {
    .field__new-line {
      /deep/ {
        path {
          stroke: $color-primary;
        }
      }
    }
  }

  &__controls {
    display: flex;
    justify-content: space-between;
  }

  &__actions {
    display: flex;
    transform: translateX(8px);
  }

  &__menu {
    margin-right: 8px;
  }

  &__new-line {
    margin-right: 8px;
  }

  &__preview {
    flex-grow: 1;
  }

  &[data-size="xs"] {
    grid-column: span 1;
    &.field--new-line {
      grid-column: 1 / span 1;
    }
    // width: calc(var(--profile-column-width) * var(--profile-xs-field));
  }

  &[data-size="sm"] {
    grid-column: span 2;
    &.field--new-line {
      grid-column: 1 / span 2;
    }
    // width: calc(var(--profile-column-width) * var(--profile-sm-field));
  }

  &[data-size="md"] {
    grid-column: span 3;
    &.field--new-line {
      grid-column: 1 / span 3;
    }
    // width: calc(var(--profile-column-width) * var(--profile-md-field));
  }

  &[data-size="lg"] {
    grid-column: span 4;
    &.field--new-line {
      grid-column: 1 / span 4;
    }
    // width: calc(var(--profile-column-width) * var(--profile-lg-field));
  }

  &[data-size="xl"] {
    grid-column: span 6;
    &.field--new-line {
      grid-column: 1 / span 6;
    }
    // width: calc(var(--profile-column-width) * var(--profile-xl-field));
  }

  &[data-size="xxl"] {
    grid-column: span 9;
    &.field--new-line {
      grid-column: 1 / span 9;
    }
    // width: calc(var(--profile-column-width) * var(--profile-xxl-field));
  }

  &[data-size="full"] {
    grid-column: span 12;
    //width: 100%;
  }

  &[data-size="auto"] {
    grid-column: auto;
  }
}
/deep/ {
  .field-ghost {
    @include dragGhost;
    position: relative;
  }
  .sortable-drag {
    @include draggingElement;
    .field__move svg path {
      fill: $color-primary;
    }
  }
}
</style>
